import { Component } from 'react';

import classNames from 'classnames';
import _ from 'lodash';
import { injectIntl } from 'react-intl';
import { Fields } from 'redux-form';

import messages from './DateInput.messages';
import styles from './DateInput.module.css';
import { months } from '../../helpers/months';
import monthMessages from '../../helpers/months.messages';
import { FormField } from '../formField';
import { FormFieldError } from '../FormFieldError/FormFieldError';
import { Select } from '../select';

class DateInput extends Component {
    renderError(fields) {
        const fieldWithError = _.find(
            fields,
            (field) => field.meta.touched && field.meta.error
        );

        if (fieldWithError) {
            return (
                fieldWithError.meta.touched &&
                fieldWithError.meta.error && (
                    <FormFieldError message={fieldWithError.meta.error} />
                )
            );
        }
    }

    renderDate = (props) => {
        const {
            fieldName,
            validateHandler,
            names,
            placeholder,
            onChangeHandler,
            disabled
        } = props;

        const field = props[fieldName];

        const renderError = this.renderError(field);

        const dateField = {
            day: names[0],
            month: names[1],
            year: names[2]
        };

        return (
            <>
                {renderError}
                <div className={styles.fields}>
                    <FormField
                        disabled={disabled}
                        placeholder={placeholder.day}
                        className={classNames(styles.day, 'fs-exclude')}
                        onChangeHandler={onChangeHandler}
                        name={dateField.day}
                        data-testid="dob-day-input"
                        validate={validateHandler}
                        hideError={true}
                    />
                    <Select
                        disabled={disabled}
                        className={classNames(styles.month, 'fs-exclude')}
                        name={dateField.month}
                        onChange={onChangeHandler}
                        validate={validateHandler}
                        hideError={true}
                        placeholder={placeholder.month}
                        messages={monthMessages}
                        selectOptions={{ options: months }}
                        data-testid="dob-month-input"
                    />
                    <FormField
                        disabled={disabled}
                        placeholder={placeholder.year}
                        className={classNames(styles.year, 'fs-exclude')}
                        onChangeHandler={onChangeHandler}
                        name={dateField.year}
                        data-testid="dob-year-input"
                        validate={validateHandler}
                        hideError={true}
                    />
                </div>
            </>
        );
    };

    render() {
        const { intl, value, label, name, validate, onChange, disabled } =
            this.props;

        const names = [`${name}.day`, `${name}.month`, `${name}.year`];

        const placeholder = {
            day: intl.formatMessage(messages.day),
            month: intl.formatMessage(messages.month),
            year: intl.formatMessage(messages.year)
        };

        return (
            <div className={styles.Date}>
                <label className={styles.label}>{label}</label>
                <Fields
                    disabled={disabled}
                    placeholder={placeholder}
                    inputValue={value}
                    onChangeHandler={onChange}
                    validateHandler={validate}
                    fieldName={name}
                    names={names}
                    component={this.renderDate}
                />
            </div>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default injectIntl(DateInput);
